import type { Instruction } from '../ir/types';
import type { RevivedRecord } from './props';

export type ActionHandler = (element: HTMLElement, event: Event) => void;

/** An island component: receives revived props and returns the instruction tree to hydrate or mount. */
export type IslandComponent = (
  props: RevivedRecord,
) => Instruction | HTMLElement;

export type IslandModule =
  | IslandComponent
  | { readonly default: IslandComponent };
export type IslandLoader = () => Promise<IslandModule>;

const islands = new Map<string, IslandLoader>();
const actions = new Map<string, ActionHandler>();

/** Registers an island under its key, `ui/Modal` style. Later registration wins, so an app can override. */
export function registerIsland(key: string, load: IslandLoader): void {
  islands.set(key, load);
}

export function islandLoader(key: string): IslandLoader | undefined {
  return islands.get(key);
}

export function registerAction(key: string, handler: ActionHandler): void {
  actions.set(key, handler);
}

export function getAction(key: string): ActionHandler | undefined {
  return actions.get(key);
}
